<template>
  <Modal v-model="visible" width="800px" :title="formData.id?'编辑合同':'新增合同'" :footer-hide="true" :mask-closable="false" class="my-modal top">
    <Form ref="form" :model="formData" :label-width="100" class="page-form less formGauge">
      <FormItem prop="subject" label="合同名称" class="full" :rules="$units.formRule.required('请输入合同名称')">
        <Input v-model="formData.subject" placeholder="请输入"/>
      </FormItem>      
      <FormItem prop="sn" label="合同编号" :rules="$units.formRule.required('请输入合同编号')">
        <Input v-model="formData.sn" placeholder="请输入"/>
      </FormItem>
      <FormItem prop="type" label="类型" :rules="$units.formRule.required('请选择合同类型')">
        <Select v-model="formData.type" filterable clearable>
          <Option value="1">新签</Option>
          <Option value="2">续签</Option>
          <Option value="3">解约</Option>
          <Option value="4">补签</Option>
        </Select>
      </FormItem>
      <FormItem prop="oldSn" label="原合同编号" v-if="formData.type==2 || formData.type==3" key="oldSn">
        <Input v-model="formData.oldSn" placeholder="请输入"/>
      </FormItem>
      <FormItem prop="nameId" label="姓名" :rules="$units.formRule.required('请选择员工')">
        <Select v-model="formData.nameId" filterable @on-change="selectEmploy">
            <Option v-for="item in userList" :value="item.id" :key="item.id"><i class="dian" :class="{'red':item.workingState==0||item.isSus==1}"></i>
            {{ item.staffNo?item.name+'-'+item.staffNo:item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem prop="staffNo" label="工号" :required="true" :show-message="false">
        <Input v-model="formData.staffNo" :disabled="true"/>
      </FormItem>
      <FormItem prop="contractBeginDate" label="开始时间" class="less" :rules="$units.formRule.objRequired('请选择开始时间')">
        <DatePicker transfer type="date" v-model="formData.contractBeginDate" format="yyyy-MM-dd" placeholder="请选择"></DatePicker>
      </FormItem>
      <FormItem prop="contractEndDate" label="结束时间" class="less" v-if="formData.type == 3" key="contractEndDate1">
        <DatePicker transfer type="date" v-model="formData.contractEndDate" format="yyyy-MM-dd" placeholder="请选择"></DatePicker>
      </FormItem>
      <FormItem prop="contractEndDate" label="结束时间" class="less" :rules="$units.formRule.objRequired('请选择结束时间')" v-else key="contractEndDate2">
        <DatePicker transfer type="date" v-model="formData.contractEndDate" format="yyyy-MM-dd" placeholder="请选择"></DatePicker>
      </FormItem>
      <FormItem prop="status" label="状态">
        <Select v-model="formData.status" filterable clearable>
            <Option value="1">已生效</Option>
            <Option value="2">待生效</Option>
            <Option value="-1">已过期</Option>
            <Option value="0">已终止</Option>
        </Select>
      </FormItem>
      <FormItem prop="documentUrls" label="具体文件" class="full" :rules="$units.formRule.required('请上传合同文件','change','array')">
        <Upload
            v-model="formData.documentUrls"
            accept=".pdf"
            fileType="pdf"
            :multiple="true"
            :showFileName="true" 
            :maxFileSize="1024 * 50"
            :limit="50"
            @change="changeUpload"
            ref="upload"
        ></Upload>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible=false">取消</Button>
      <Button type="primary" @click="submit" :loading="loading">提交</Button>
    </div>
  </Modal>
</template>

<script>
import Upload from '@/components/commons/Upload/index';
export default {
  components: {
    Upload
  },
  props: [],
  data() {
    return {
      visible: false,
      loading:false,
      formData:{
        subject:"",
        sn:"",
        oldSn:'',
        type:'',
        status:'',
        employName:"",
        staffNo:"",
        contractBeginDate:null,
        contractEndDate:null,
        documentUrls:[]
      },
      userList:[],
      userType:''
    };
  },
  methods: {
    open(data={}) {
      this.$refs.form&&this.$refs.form.resetFields();
      const formData = JSON.parse(JSON.stringify(data));
      try {
        formData.documentUrls = JSON.parse(formData.documentUrls);
      } catch (error) {
        console.log("documentUrls转化异常")
      }
      if(!formData.documentUrls){
        formData.documentUrls = [];
        this.$refs.upload.clear();
      }
      // 区分内勤人员业务员
      if(formData.employId){
        formData.nameId = formData.employId
      }else{
        formData.nameId = formData.indoorStaffId
      }
      this.formData = formData;
      this.visible = true;
      this.getUserList();
    },
    // 合同上传成功
    changeUpload(data) {
      this.formData.documentUrls = data;
    },
    // 选择员工
    selectEmploy(id){
      const bean = this.userList.find((item)=>{
        return item.id == id;
      });
      if(bean){
        this.formData.staffNo = bean.staffNo;
        this.formData.employName = bean.name;
      }else{
        this.formData.staffNo = '';
        this.formData.employName = '';
      }
    },
    // 获取员工列表
    getUserList(){
      this.$http({
        type: "POST",
        url: "/buz/userBase/getByOrgIds",
        data: {
          type:3
        }
      }).then(res => {
        this.userList = res.data;
      })
    },
    getUserType(id){
      this.userList.forEach((item)=>{
          if(item.id == id){
            this.userType = item.type
          }
        })
    },
    submit(){
      console.log("validate")
      this.$refs.form.validate().then(isok=>{
        if(!isok){
          return;
        }

        if(this.formData.type!=3&&this.formData.contractBeginDate>this.formData.contractEndDate){
          this.$notice.error("合同开始时间不能大于结束时间");
          return;
        }


        // 区分内勤人员业务员

        this.getUserType(this.formData.nameId)

        let formData
        if(this.userType == 1){
          formData = {
            contractBeginDate:this.$units.formatDate(this.formData.contractBeginDate),
            contractEndDate:this.$units.formatDate(this.formData.contractEndDate),
            documentUrls:JSON.stringify(this.formData.documentUrls),
            type:this.formData.type,
            employId:this.formData.nameId,
            staffNo:this.formData.staffNo,
            employName:this.formData.employName,
            sn:this.formData.sn,
            subject:this.formData.subject,
            oldSn:this.formData.oldSn,
            status:this.formData.status
          }
        }else{
          formData = {
            contractBeginDate:this.$units.formatDate(this.formData.contractBeginDate),
            contractEndDate:this.$units.formatDate(this.formData.contractEndDate),
            documentUrls:JSON.stringify(this.formData.documentUrls),
            type:this.formData.type,
            indoorStaffId:this.formData.nameId,
            staffNo:this.formData.staffNo,
            employName:this.formData.employName,
            sn:this.formData.sn,
            subject:this.formData.subject,
            oldSn:this.formData.oldSn,
            status:this.formData.status
          }
        }
        if(this.formData.id){
          formData.id = this.formData.id;
        }
        if(this.loading){
          return;
        }
        this.loading = true;
        this.$http({
          type: "POST",
          url: formData.id?"/buz/userContract/edit":"/buz/userContract/add",
          data: formData,
          apiPermissionCode:'org_6_2'
        }).then(res => {
          this.$notice.success("提交成功");
          this.visible = false;
          this.$emit("suceess")
        }).finally(res => {
          this.loading = false;
        });
      })
    },
  },

};
</script>
<style lang="scss" scoped>
.dian {
  display: inline-block;
  margin-bottom: 2px;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
  &.red {
      background: #e3461f;
  }
}
</style>
